import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

export default function BrandLogo() {
  const { pathname } = useLocation();
  const [ready, setReady] = useState(false);
  const [pass, setPass] = useState(0);
  return <div className="bz-logo-art" style={{ '--bz-logo-mask': "url('/assets/logo-blue.png')" }} onPointerEnter={event => {
    if (event.pointerType === 'mouse') setPass(value => value + 1);
  }}>
    <img src="/assets/logo-blue.png" alt="Bezalel Technology" width="184" height="78" onLoad={() => setReady(true)}/>
    {ready && <i key={`${pathname}:${pass}`} className="bz-logo-shine" aria-hidden="true"/>}
  </div>;
}
